import * as React from 'react';
import { AlignedWrapper, ShadeContainer, ShadesWrapper } from './ShadeGridStyles';
import { ShadeInfo } from './ShadeInfo';
import { IShadeGrid } from '../../interfaces/IShadePicker';
import { ShadeImages } from './ShadeImages';
import { classes } from '../../utils/Classes';

export const ShadeGrid = (props: IShadeGrid) => {
    const shadesContainerClassNames = classes('product-shades-container');
    const shadesGridWrapperClassNames = classes('product-shades-grid-wrapper');

    const getShadeInfo = () => {
        const { shadeDescriptionPosition, shadeNamePosition, separator, selectedShade } = props;

        return (
            <ShadeInfo
                selectedShade={selectedShade}
                separator={separator}
                shadeDescriptionPosition={shadeDescriptionPosition}
                shadeNamePosition={shadeNamePosition}
            />
        );
    };

    const getShadeInfoInline = () => {
        const { filteredShades, shadeConfig } = props;

        return (
            <ShadeContainer className={shadesContainerClassNames}>
                <AlignedWrapper>
                    <ShadeImages filteredShades={filteredShades} shadeConfig={shadeConfig} />
                </AlignedWrapper>
                <AlignedWrapper>{getShadeInfo()}</AlignedWrapper>
            </ShadeContainer>
        );
    };

    const getShadesInfoMultiline = () => {
        const { filteredShades, shadeConfig, shadeInfoAbovePicker, shadeInfoBelowPicker } = props;

        return (
            <>
                {shadeInfoAbovePicker && getShadeInfo()}
                <ShadeContainer className={shadesContainerClassNames}>
                    <ShadesWrapper className={shadesGridWrapperClassNames}>
                        <ShadeImages filteredShades={filteredShades} shadeConfig={shadeConfig} />
                    </ShadesWrapper>
                </ShadeContainer>
                {shadeInfoBelowPicker && getShadeInfo()}
            </>
        );
    };

    const { isShadeInfoInline } = props;

    return isShadeInfoInline ? getShadeInfoInline() : getShadesInfoMultiline();
};
